import { Location } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  UntypedFormArray,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { MaintenanceComparisonValue } from 'src/app/maintenance/components/maintenance-comparison-page/maintenance-comparison-page.component';
import { MaintenanceParameterValueDto } from 'src/app/shared/flight-log-api/maintenance/maintenance-client.model';
import { dateTime24HourFormat, hasMinimumYear, isDate } from 'src/util/dateLib';

export function dateAndYearValidator(control: UntypedFormControl) {
  const value = control.value as string;
  if (value != null) {
    if (!isDate(value)) {
      return {
        date: {
          message: 'Invalid date.',
        },
      };
    } else if (!hasMinimumYear(value, 1900)) {
      return {
        date: {
          message: 'Invalid year. Must be a four digit year. Example: 2019',
        },
      };
    }
  }
  return null;
}

@Component({
  selector: 'fl-maintenance-comparison-form',
  templateUrl: './maintenance-comparison-form.component.html',
  styleUrls: ['./maintenance-comparison-form.component.scss'],
})
export class MaintenanceComparisonFormComponent implements OnInit {
  @Input()
  public values: MaintenanceComparisonValue[];
  @Output()
  public save = new EventEmitter<{
    remarks: string;
    values: MaintenanceParameterValueDto[];
    snapshotEffectiveDate: Date;
  }>();

  public form: UntypedFormGroup;

  public dateTimeFormat = dateTime24HourFormat;

  get controls() {
    return (this.form.get('values') as UntypedFormArray).controls as UntypedFormGroup[];
  }

  get remarksCtrl() {
    return this.form.get('remarks') as UntypedFormControl;
  }

  public columns = [
    { name: 'Parameter', span: 4 },
    { name: 'Ramco Value', span: 2 },
    { name: 'FL Value', span: 2 },
  ];

  constructor(private _fb: UntypedFormBuilder, private location: Location) {}

  public ngOnInit() {
    this.form = this._fb.group({
      remarks: [null, Validators.required],
      values: this._fb.array(
        this.values.map((item) =>
          this._fb.group({
            text: [item.text],
            paramName: [item.paramName, Validators.required],
            engineNumber: [item.engineNumber],
            flightLogValue: [item.flightLogValue, Validators.required],
            ramcoValue: item.ramcoValue,
          }),
        ),
      ),
      snapshotEffectiveDate: [new Date(), dateAndYearValidator],
    });
  }

  public onSave() {
    if (this.form.valid) {
      const values: MaintenanceParameterValueDto[] = this.controls
        .map((fg) => fg.value)
        .map((cv: any) => ({
          name: cv.paramName,
          engineNumber: cv.engineNumber,
          value: cv.flightLogValue,
        }));
      this.save.emit({
        remarks: this.form.value.remarks,
        values,
        snapshotEffectiveDate: this.form.value.snapshotEffectiveDate,
      });
      this.remarksCtrl.setValue(null);
    }
  }

  public onCancel() {
    this.location.back();
  }

  public onCopyRamco() {
    this.controls.forEach((ctrl) => {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      ctrl.get('flightLogValue')!.patchValue(ctrl.get('ramcoValue')!.value);
    });
  }

  public onReset() {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    this.controls.map((ctrl) => ctrl.get('flightLogValue')!.patchValue(null));
  }
}
